<template>
  <div>
    <b-card no-body>

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>{{ $t('Entries') }}</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block ml-50 mr-1"
            />
            <b-button
              v-b-toggle.sidebar-create-monitoring
              variant="primary"
            >
              {{ $t('Create') }}
            </b-button>
            <b-link
              :to="{ name: 'monitoring-report'}"
              class="btn btn-primary ml-1"
            >
              {{ $t('Monitoring Report') }}
            </b-link>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                :placeholder="$t('Search...')"
              />
            </div>
          </b-col>
        </b-row>
      </div>
      <b-table
        ref="monitoringTable"
        :items="list"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        :empty-text="$t('No matching records found')"
        :sort-desc.sync="isSortDirDesc"
        :busy="isBusy"
        class="position-relative"
      >
        <template #head()="data">
          {{ $t(data.label) }}
        </template>

        <!-- Column: Id -->
        <template #cell(index)="data">
          {{ data.index + 1 }}
        </template>

        <!-- Column: Id -->
        <template #cell(name)="data">
          {{ data.value }}
        </template>
        <template #cell(work_type)="data">
          {{ get_work_type(data.value) }}
        </template>

        <template #cell(full_period)="data">
          {{ data.value.year }}/{{ data.value.quarter }}
        </template>
        <template #cell(file)="data">
          <a :href="data.value">{{ $t('File') }}</a>
        </template>

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner
              variant="primary"
              label="Text Centered"
            />
          </div>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">

          <div class="text-nowrap">
            <feather-icon
              v-b-toggle.sidebar-create-monitoring
              icon="EditIcon"
              class="cursor-pointer"
              size="16"
              @click="update(data.item)"
            />

            <feather-icon
              :id="`invoice-row-${data.item.id}-preview-icon`"
              icon="TrashIcon"
              size="16"
              class="mx-1 cursor-pointer"
              @click="remove(data.item)"
            />
          </div>
        </template>

      </b-table>

      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">{{ $t("table summary", { from: dataMeta.from, to: dataMeta.to, of: dataMeta.of }) }} </span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="total"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>
        </b-row>
      </div>
      <create @refetchData="refetchData" />
    </b-card>
    <b-card
      id="guide"
      style="font-family: TimesNewRoman,serif; font-size: 18px;text-align: center; color: red"
    >
      <p style="font-size: 40px;">
        <strong>Minimum talablar yo'riqnomasi</strong>
      </p>
    </b-card>
    <component :is="localeComponent" />
  </div>

</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BSpinner,
  BTable, BPagination, VBToggle, BLink,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { onUnmounted } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import config from './config'
import monitoringModule from '@/store/monitoring/index'
import Create from './Create.vue'
import minimumGuideUz from './minimum-guide/uz.vue'
import minimumGuideRU from './minimum-guide/ru.vue'
import minimumGuideEN from './minimum-guide/en.vue'

export default {
  name: 'Monitoring',
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BSpinner,
    BTable,
    BPagination,
    vSelect,
    Create,
    BLink,
    minimumGuideUz,
    minimumGuideRU,
    minimumGuideEN,
  },
  computed: {
    localeComponent() {
      const components = {
        uz: minimumGuideUz,
        ru: minimumGuideRU,
        en: minimumGuideEN,
      }
      return components[this.$i18n.locale] || minimumGuideEN
    },
  },
  created() {
    this.$store.commit(`${this.MODULE_NAME_MONITORING}/FRESH`)
  },
  methods: {
    get_work_type(workType) {
      const workTypeData = this.$store.getters['staticModule/getScientificWorkType']?.(workType)
      if (!workTypeData || typeof workTypeData !== 'object') {
        return 'Boshqa' // Replace with an appropriate default
      }

      // Check if the requested locale exists, otherwise return a fallback
      return workTypeData[this.$i18n.locale] ?? 'Boshqa'
    },
    remove(data) {
      this.$removeSwal(this, data, `${this.MODULE_NAME_MONITORING}/del`, this.refetchData)
    },
    update(data) {
      this.$store.commit(`${this.MODULE_NAME_MONITORING}/UPDATE`, data)
    },
  },

  setup() {
    const MODULE_NAME_MONITORING = 'monitoring'

    // Register module
    if (!store.hasModule(MODULE_NAME_MONITORING)) store.registerModule(MODULE_NAME_MONITORING, monitoringModule)

    onUnmounted(() => {
      if (store.hasModule(MODULE_NAME_MONITORING)) store.unregisterModule(MODULE_NAME_MONITORING, monitoringModule)
    })
    return {
      MODULE_NAME_MONITORING,
      ...config(),
    }
  },
}
</script>

<style scoped>

</style>
